export default function*({ payload }) {
  if (payload.paypal_approval_url) {
    window.open(payload.paypal_approval_url, '_self')
    yield
  }
  return
}
